/* src/app/add-note/add-name/add-name.scss */
:root {
  --ion-background-color:
    linear-gradient(
      299deg,
      #371A09 2.43%,
      #885F26 100%);
  --ion-dark-background: #624120;
  --ion-color-primary-lightbrown: #785838;
  --ion-color-primary-lightgreen: #24615B;
  --ion-color-primary: #3880ff;
  --ion-color-primary-rgb:
    56,
    128,
    255;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-primary-shade: #3171e0;
  --ion-color-primary-tint: #4c8dff;
  --ion-color-primary-brown: #62412080;
  --ion-color-primary-brown-light: #9a6d3a;
  --ion-color-primary-darkgreen: #004147;
  --ion-color-primary-lightblue: #3FDECE;
  --ion-color-secondary: #3dc2ff;
  --ion-color-secondary-rgb:
    61,
    194,
    255;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-secondary-shade: #36abe0;
  --ion-color-secondary-tint: #50c8ff;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb:
    82,
    96,
    255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #2dd36f;
  --ion-color-success-rgb:
    45,
    211,
    111;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb:
    255,
    255,
    255;
  --ion-color-success-shade: #28ba62;
  --ion-color-success-tint: #42d77d;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb:
    255,
    196,
    9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb:
    0,
    0,
    0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb:
    235,
    68,
    90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb:
    255,
    255,
    255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-dark: #222428;
  --ion-color-dark-rgb:
    34,
    36,
    40;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb:
    255,
    255,
    255;
  --ion-color-dark-shade: #1e2023;
  --ion-color-dark-tint: #383a3e;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb:
    146,
    148,
    156;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb:
    255,
    255,
    255;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #f4f5f8;
  --ion-color-light-rgb:
    244,
    245,
    248;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb:
    0,
    0,
    0;
  --ion-color-light-shade: #d7d8da;
  --ion-color-light-tint: #f5f6f9;
  --gentle-rock-scale: 1.2;
}
@media (prefers-color-scheme: dark) {
  body {
    --ion-color-primary: #428cff;
    --ion-color-primary-rgb:
      66,
      140,
      255;
    --ion-color-primary-contrast: #ffffff;
    --ion-color-primary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-primary-shade: #3a7be0;
    --ion-color-primary-tint: #5598ff;
    --ion-color-secondary: #50c8ff;
    --ion-color-secondary-rgb:
      80,
      200,
      255;
    --ion-color-secondary-contrast: #ffffff;
    --ion-color-secondary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-secondary-shade: #46b0e0;
    --ion-color-secondary-tint: #62ceff;
    --ion-color-tertiary: #6a64ff;
    --ion-color-tertiary-rgb:
      106,
      100,
      255;
    --ion-color-tertiary-contrast: #ffffff;
    --ion-color-tertiary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-tertiary-shade: #5d58e0;
    --ion-color-tertiary-tint: #7974ff;
    --ion-color-success: #3FDECE;
    --ion-color-success-rgb:
      63,
      222,
      206;
    --ion-color-success-contrast: #000000;
    --ion-color-success-contrast-rgb:
      0,
      0,
      0;
    --ion-color-success-shade: #29c467;
    --ion-color-success-tint: #44e283;
    --ion-color-warning: #ffd534;
    --ion-color-warning-rgb:
      255,
      213,
      52;
    --ion-color-warning-contrast: #000000;
    --ion-color-warning-contrast-rgb:
      0,
      0,
      0;
    --ion-color-warning-shade: #e0bb2e;
    --ion-color-warning-tint: #ffd948;
    --ion-color-danger: #ff4961;
    --ion-color-danger-rgb:
      255,
      73,
      97;
    --ion-color-danger-contrast: #ffffff;
    --ion-color-danger-contrast-rgb:
      255,
      255,
      255;
    --ion-color-danger-shade: #e04055;
    --ion-color-danger-tint: #ff5b71;
    --ion-color-dark: #f4f5f8;
    --ion-color-dark-rgb:
      244,
      245,
      248;
    --ion-color-dark-contrast: #000000;
    --ion-color-dark-contrast-rgb:
      0,
      0,
      0;
    --ion-color-dark-shade: #d7d8da;
    --ion-color-dark-tint: #f5f6f9;
    --ion-color-medium: #989aa2;
    --ion-color-medium-rgb:
      152,
      154,
      162;
    --ion-color-medium-contrast: #000000;
    --ion-color-medium-contrast-rgb:
      0,
      0,
      0;
    --ion-color-medium-shade: #86888f;
    --ion-color-medium-tint: #a2a4ab;
    --ion-color-light: #222428;
    --ion-color-light-rgb:
      34,
      36,
      40;
    --ion-color-light-contrast: #ffffff;
    --ion-color-light-contrast-rgb:
      255,
      255,
      255;
    --ion-color-light-shade: #1e2023;
    --ion-color-light-tint: #383a3e;
  }
  .ios body {
    --ion-text-color: #ffffff;
    --ion-text-color-rgb:
      255,
      255,
      255;
    --ion-color-step-50: #0d0d0d;
    --ion-color-step-100: #1a1a1a;
    --ion-color-step-150: #262626;
    --ion-color-step-200: #333333;
    --ion-color-step-250: #404040;
    --ion-color-step-300: #4d4d4d;
    --ion-color-step-350: #595959;
    --ion-color-step-400: #666666;
    --ion-color-step-450: #737373;
    --ion-color-step-500: #808080;
    --ion-color-step-550: #8c8c8c;
    --ion-color-step-600: #999999;
    --ion-color-step-650: #a6a6a6;
    --ion-color-step-700: #b3b3b3;
    --ion-color-step-750: #bfbfbf;
    --ion-color-step-800: #cccccc;
    --ion-color-step-850: #d9d9d9;
    --ion-color-step-900: #e6e6e6;
    --ion-color-step-950: #f2f2f2;
    --ion-item-background: #000000;
    --ion-card-background: #1c1c1d;
  }
  .ios ion-modal {
    --ion-background-color: var(--ion-color-step-100);
    --ion-toolbar-background: var(--ion-color-step-150);
    --ion-toolbar-border-color: var(--ion-color-step-250);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  ::ng-deep .buttons .button {
    flex: 0 0 55% !important;
    margin: 0 auto !important;
    height: 68px !important;
    font-size: 16px !important;
  }
}
@media screen and (min-width: 1130px) {
  ::ng-deep .buttons .button {
    height: 68px !important;
    font-size: 16px !important;
  }
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  ::ng-deep .buttons .button {
    height: 45px !important;
  }
}
.wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    linear-gradient(
      299deg,
      #371A09 2.43%,
      #885F26 100%);
}
.wrapper .content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
}
.wrapper .header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 27px 24px 0 0;
}
.wrapper .header .logo {
  width: 50px;
  height: 50px;
}
@media screen and (min-width: 768px) {
  .wrapper .header .logo {
    width: 80px;
    height: 80px;
  }
}
@media screen and (orientation: landscape) {
  .wrapper .header .logo {
    width: 50px;
    height: 50px;
  }
}
.wrapper .main {
  border-radius: 45px 45px 0 0;
  height: 80vh;
  background-color: var(--ion-color-primary-darkgreen);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 20px 10px;
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main {
    height: 70vh;
  }
}
.wrapper .main .mr-potty {
  position: absolute;
  top: -60px;
  right: 80px;
  z-index: -1;
}
@media screen and (max-width: 380px) {
  .wrapper .main .mr-potty {
    right: 60px;
  }
}
@media screen and (min-width: 500px) {
  .wrapper .main .mr-potty {
    right: 130px;
  }
}
@media screen and (min-width: 768px) {
  .wrapper .main .mr-potty {
    right: 230px;
  }
}
@media screen and (orientation: landscape) {
  .wrapper .main .mr-potty {
    right: 250px;
  }
}
.wrapper .main .arms {
  position: absolute;
  top: -11px;
  right: 140px;
}
@media screen and (max-width: 380px) {
  .wrapper .main .arms {
    right: 121px;
  }
}
@media screen and (min-width: 500px) {
  .wrapper .main .arms {
    right: 190px;
  }
}
@media screen and (min-width: 768px) {
  .wrapper .main .arms {
    right: 290px;
  }
}
@media screen and (orientation: landscape) {
  .wrapper .main .arms {
    right: 310px;
  }
}
.wrapper .main .arms .right-arm {
  position: absolute;
  top: -2px;
  left: 60px;
}
.wrapper .main .arms .bubble {
  position: absolute;
  top: -120px;
  left: -155px;
  transform: rotate(13deg);
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .arms .bubble {
    top: -90px;
    left: -140px;
    width: 120px;
  }
}
.wrapper .main .arms .bubble-text {
  position: absolute;
  top: 30px;
  left: 15px;
  transform: rotate(-13deg);
  width: 100px;
  color: #624120;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .arms .bubble-text {
    top: 18px;
    left: 3px;
  }
}
.wrapper .main .main-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrapper .main .main-content .title {
  width: 275px;
  color: var(--ion-color-primary-contrast);
  text-align: center;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
}
@media screen and (max-width: 380px) {
  .wrapper .main .main-content .title {
    font-size: 20px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content .title {
    width: 330px;
    font-size: 35px;
  }
}
@media screen and (min-width: 1130px) {
  .wrapper .main .main-content .title {
    width: 330px;
    font-size: 35px;
  }
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .main-content .title {
    width: 360px;
    font-size: 25px;
    margin-top: 5px;
  }
}
.wrapper .main .main-content app-progress-bar {
  margin-top: 10px;
  margin-bottom: 58px;
}
@media screen and (max-height: 752px) and (orientation: portrait) {
  .wrapper .main .main-content app-progress-bar {
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 380px) and (max-height: 700px) {
  .wrapper .main .main-content app-progress-bar {
    margin: 5px 0 15px 0;
  }
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .main-content app-progress-bar {
    margin: 5px 0 20px 0;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content app-progress-bar {
    margin: 40px 0;
  }
}
.wrapper .main .main-content .main-input {
  margin-bottom: 60px;
  width: 330px;
  height: 58px;
  flex-shrink: 0;
  color: var(--ion-color-primary-contrast);
  border: none;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.25);
  font-size: 16px;
  padding-left: 30px;
}
.wrapper .main .main-content .main-input::placeholder {
  font-size: 14px;
  color: var(--ion-color-primary-contrast);
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content .main-input::placeholder {
    font-size: 18px;
  }
}
.wrapper .main .main-content .main-input:focus {
  font-size: 18px;
  border: 1px solid var(--ion-color-primary-contrast);
}
.wrapper .main .main-content .main-input:focus::placeholder {
  color: transparent;
}
@media screen and (max-height: 752px) and (orientation: portrait) {
  .wrapper .main .main-content .main-input {
    margin-bottom: 30px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content .main-input {
    width: 410px;
    height: 64px;
    font-size: 18px;
  }
}
@media screen and (min-width: 1130px) {
  .wrapper .main .main-content .main-input {
    width: 410px;
    height: 64px;
    font-size: 18px;
  }
}
@media screen and (max-width: 380px) and (max-height: 700px) {
  .wrapper .main .main-content .main-input {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 350px) and (orientation: portrait) {
  .wrapper .main .main-content .main-input {
    width: 100%;
  }
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .main-content .main-input {
    height: 50px;
    font-size: 14px;
    margin-bottom: 10px;
  }
}
.wrapper .main .main-content .checkbox-block {
  display: flex;
  align-items: center;
  gap: 10px;
}
.wrapper .main .main-content .checkbox-block .custom-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ion-color-primary-contrast);
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content .checkbox-block .custom-checkbox {
    font-size: 20px;
  }
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .main-content .checkbox-block .custom-checkbox {
    font-size: 14px;
  }
}
.wrapper .main .main-content .checkbox-block .custom-checkbox ion-checkbox {
  --size: 20px;
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .main-content .checkbox-block .custom-checkbox ion-checkbox {
    --size: 15px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content .checkbox-block .custom-checkbox ion-checkbox {
    --size: 22px;
  }
}
.wrapper .main .main-content .checkbox-block .custom-checkbox ion-checkbox::part(container) {
  background-color: transparent;
  border-radius: 6px;
  border: 2px solid var(--ion-color-primary-contrast);
}
@media screen and (orientation: landscape) and (max-width: 900px) {
  .wrapper .main .main-content .checkbox-block .custom-checkbox ion-checkbox::part(container) {
    border-radius: 4px;
  }
}
.wrapper .main .main-content .checkbox-block .question {
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .main-content .checkbox-block .question {
    width: 30px;
    height: 30px;
    margin-bottom: 5px;
  }
}
.wrapper .main .mr-toilet-block {
  height: 1px;
  animation: fade-in 1s ease-in;
  flex: 1;
  width: 100%;
  position: relative;
}
@media screen and (orientation: landscape) {
  .wrapper .main .mr-toilet-block {
    position: absolute;
    top: 20px;
    left: 10px;
  }
}
.wrapper .main .mr-toilet-block .mr-toilet {
  position: absolute;
  top: 66%;
  left: -30px;
  transform: translate(0, -70%) rotate(43deg);
  transition: all 0.5s ease-out;
}
@media screen and (max-width: 380px) and (max-height: 668px) {
  .wrapper .main .mr-toilet-block .mr-toilet {
    top: unset;
    bottom: 20px;
    left: -30px;
    transform: rotate(43deg);
  }
}
@media screen and (max-width: 380px) and (max-height: 668px) {
  .wrapper .main .mr-toilet-block .mr-toilet img {
    width: 70px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .mr-toilet-block .mr-toilet img {
    width: 150px;
  }
}
@media screen and (min-width: 1130px) {
  .wrapper .main .mr-toilet-block .mr-toilet img {
    width: 150px;
  }
}
.wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble {
  position: absolute;
  top: -130px;
  right: -130px;
  transform: rotate(-40deg);
}
@media screen and (max-width: 380px) and (max-height: 668px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble {
    top: -110px;
    right: -120px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble {
    top: -150px;
    right: -140px;
  }
}
@media screen and (min-width: 1130px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble {
    top: -150px;
    right: -140px;
  }
}
@media screen and (max-width: 380px) and (max-height: 668px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble img {
    width: 150px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble img {
    width: 200px;
    top: -150px;
    right: -140px;
  }
}
@media screen and (min-width: 1130px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble img {
    width: 200px;
    top: -150px;
    right: -140px;
  }
}
@media screen and (orientation: landscape) and (max-width: 700px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble {
    width: 130px;
    top: -80px;
    right: -80px;
  }
}
.wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble__text {
  transform: rotate(-3deg);
  position: absolute;
  top: 15px;
  left: 50px;
  font-size: 11px;
  width: 92px;
  height: 63px;
  color: #624120;
  text-align: center;
  font-weight: 700;
  line-height: 12px;
}
@media screen and (max-width: 380px) and (max-height: 668px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble__text {
    top: 12px;
    left: 44px;
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble__text {
    width: 142px;
    line-height: 16px;
    font-size: 17px;
  }
}
@media screen and (min-width: 1130px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble__text {
    width: 142px;
    line-height: 16px;
    font-size: 17px;
  }
}
@media screen and (orientation: landscape) and (max-width: 700px) {
  .wrapper .main .mr-toilet-block .mr-toilet .reversed-bubble__text {
    top: 7px;
    left: 30px;
    font-size: 10px;
  }
}
/*# sourceMappingURL=add-name.css.map */
